<template>
  <v-container class="User">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar v-if="item" class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2><v-icon large class="mr-2"  >mdi-account</v-icon>{{ $t('administration.user.initpassword') }}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"
          :to="{ name: 'UserShow' , params: { id: item['@id'] } }"
        >
          {{ $t('global.back')}}
        </v-btn>
        <v-btn
          class="ml-2"
          color="primary"
          @click="initpassword"
        >
          {{ $t('global.init')}}
        </v-btn>
      </div>
    </v-toolbar>
    <div  v-if="item">
      <br>
      <p class="ml-4">{{ $t('administration.user.initpassworduser')}} : <strong>{{ item['login'] }}</strong>
      </p>
    </div>

    <Loading :visible="isLoading" />
  </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters,mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';

const servicePrefix = 'User';

export default {
  name: 'UserInitPassword',
  servicePrefix,
  components: {
      Loading,
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields(['error', 'isLoading', 'violations']),
    ...mapState('user', {
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    }),
    ...mapGetters('user', ['find'])
  },
  methods: {
    ...mapActions('user', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    }),
    ...mapActions({
      userPushAction: 'user/action'
    }),
    initpassword() {
      let action = 'user/'+this.item.id+'/edit/initpassword';
        this.userPushAction({action: action,values: {
       }});
    },

    initconfirm(item_return) {
      this.$router.push({ name: `UserInitPasswordConfirm` , params: { id: '/api/users/'+this.item.id, passwordtemp: item_return.passwordTemp }});
      this.showMessage(item_return.message);
    },
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      let action = 'user/'+this.item.id+'/edit/initpassword';
      if (this.action == action) {
        this.initconfirm(actioned);
      }
    },

    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
